import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { getGlobalStyleSheets } from '../../global-styles';
import { HeaderProps } from './layout.props';

import LogoWhite from '@kpmg-uk/tti-design-styles/dist/assets/images/logo-white.svg';

import * as TagNames from './layouts.tagnames';

@customElement(TagNames.HeaderContent)
export class AtlHeaderContent extends LitElement implements HeaderProps {
   declare appTitle: string;
   declare homeRoute: string;
   declare imageSrc: string;
   declare logoUrl: string;
   declare protected isMobile: boolean;

   static properties = {
      appTitle: { type: String },
      homeRoute: { type: String },
      imageSrc: { type: String },
      logoUrl: { type: String },
      isMobile: { type: Boolean, state: true },
   };

   constructor() {
      super();
      this.isMobile = window.innerWidth <= 992;
   }

   static styles = [
      ...getGlobalStyleSheets(),
      css`
         :host {
            display: block;
         }
      `,
   ];

   connectedCallback() {
      super.connectedCallback();
      window.addEventListener('resize', this._handleResize);
   }

   disconnectedCallback(): void {
      window.removeEventListener('resize', this._handleResize);
      super.disconnectedCallback();
   }

   private _renderAppTitle = () => {
      if (this.appTitle && typeof this.appTitle === 'string') {
         return html`<span class="app-title text-nowrap"
            >${this.appTitle}</span
         >`;
      }
      return html`${this.appTitle}`;
   };

   private _renderContent = () => {
      if (this.isMobile) {
         return html`<div style="display: inline-flex; gap: 28px">
            <slot name="nav-mobile"></slot>
            <span class="fw-bold fs-2 text-white">
               ${this._renderAppTitle()}
            </span>
         </div> `;
      }

      const logo = this.imageSrc ?? LogoWhite;
      return html`
         <div class="left">
            <div class="logo">
               <a href="${this.homeRoute}" class="p-2">
                  <img
                     class="logo"
                     href="${this.logoUrl}"
                     src="${logo}"
                     alt="Kpmg Logo"
                  />
               </a>
            </div>
            <slot name="nav-left"></slot>
         </div>
         <div class="title">${this._renderAppTitle()}</div>
         <div class="right">
            <slot name="nav-right"></slot>
         </div>
      `;
   };

   render() {
      return html`
         <header class="atl-wc-mainheader-no-sidebar px-3">
            <div class="content">${this._renderContent()}</div>
            <slot name="additional-content"></slot>
         </header>
      `;
   }

   private _handleResize = () => {
      this.isMobile = window.innerWidth <= 992 ? true : false;
   };
}
